import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../../config';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import { isValidGSTIN, isValidPincode, isValidPhone } from '../../common/validators';
// import CitySelector from '../CitySelector';
import { toast } from 'react-toastify';
import Select from 'react-select';



const firmTypeOptions = [
    { value: 'Propritor', label: 'Propritor' },
    { value: 'PVT Ltd', label: 'PVT Ltd' },
    { value: 'Ltd', label: 'Ltd' },
    { value: 'Partnership', label: 'Partnership' },
];

const gstRegistrationOptions = [
    { value: 'registered', label: 'GST Registered' },
    { value: 'URD', label: 'URD (Unregistered Dealer)' },
];

function BuyerEditModal({ show, onHide, buyer, onBuyerUpdated }) {
    const [form, setForm] = useState({
        business_name: '',
        alias: '',
        industry_type: '',
        firm_type: '',
        gst_registration: '',
        gstin: '',
        business_email: '',
        owner_name: '',
        owner_contact_no: '',
        address: '',
        town: '',
        city: '',
        state: '',
        pin_code: '',
        country: 'India',
        credit_period_allowed: '',
        pan_no: '',
        tan_no: '',
        fssai_no: ''
    });

    const [formSubmitted, setFormSubmitted] = useState(false);

    // Populate form from buyer prop
    useEffect(() => {
        if (buyer) {
            setForm({
                business_name: buyer.business_name || '',
                alias: buyer.alias || '',
                industry_type: buyer.industry_type || '',
                firm_type: buyer.firm_type || '',
                gst_registration: buyer.gst_registration || '',
                gstin: buyer.gstin || '',
                business_email: buyer.business_email || '',
                owner_name: buyer.owner_name || '',
                owner_contact_no: buyer.owner_contact_no || '',
                address: buyer.address || '',
                town: buyer.town || '',
                city: buyer.city || '',
                state: buyer.state || '',
                pin_code: buyer.pin_code || '',
                country: 'India',
                credit_period_allowed: buyer.credit_period_allowed || '',
                pan_no: buyer.pan_no || '',
                tan_no: buyer.tan_no || '',
                fssai_no: buyer.fssai_no || '',
                isInHouse: buyer.isInHouse || false
            });
        }
    }, [buyer]);

    const [industryTypes, setIndustryTypes] = useState([]);

    useEffect(() => {
        const fetchIndustryTypes = async () => {
            try {
                const res = await axios.get(`${config.API_BASE_URL}/industry_type`);
                setIndustryTypes(res.data || []);
            } catch (err) {
                console.error('Failed to fetch industry types:', err);
            }
        };
        fetchIndustryTypes();
    }, []);
    // Sample select options
    const industryTypeOptions = industryTypes.map((type) => ({
        value: type._id,
        label: type.name,
    }));

    const handleChange = e => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSelectChange = (selected, action) => {
        setForm(prev => ({ ...prev, [action.name]: selected?.value }));
    };

    const handleOwnerChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async e => {
        e.preventDefault();
        setFormSubmitted(true);

        if (!form.town || !form.pin_code || !form.state || !form.city || !form.address || !form.business_name || !form.industry_type || !form.firm_type || !form.owner_name || !isValidPhone(form.owner_contact_no)) {
            return; // Prevent invalid submission
        }

        try {
            const response = await axios.put(`${config.API_BASE_URL}/buyers/${buyer._id}`, form);

            if (response.data.success) {
                toast.success(response.data.message || 'Buyer updated successfully!');
            }
            onBuyerUpdated();
            onHide();
        } catch (err) {
            console.error('Update buyer failed:', err);
            const errorMessage = err.response?.data?.message || 'Failed to update buyer!';
            toast.error(errorMessage);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Buyer Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        {/* Business & Industry Info */}
                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Business Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="business_name"
                                    value={form.business_name}
                                    onChange={handleChange}
                                    isInvalid={formSubmitted && !form.business_name}
                                />
                                <Form.Control.Feedback type="invalid">Business name is required.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Alias</Form.Label>
                                <Form.Control name="alias" value={form.alias} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Industry Type <span className="text-danger">*</span></Form.Label>
                                <Select
                                    name="industry_type"
                                    value={industryTypeOptions.find(opt => opt.value === form.industry_type?._id)}
                                    onChange={handleSelectChange}
                                    options={industryTypeOptions}
                                    placeholder="-- Select Industry Type --"
                                    classNamePrefix="react-select"
                                    className={formSubmitted && !form.industry_type ? 'is-invalid fs-9' : 'fs-9'}
                                />
                                {formSubmitted && !form.industry_type && (
                                    <div className="invalid-feedback d-block">Industry Type is required.</div>
                                )}
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Firm Type <span className="text-danger">*</span></Form.Label>
                                <Select
                                    name="firm_type"
                                    value={firmTypeOptions.find(opt => opt.value === form.firm_type)}
                                    onChange={handleSelectChange}
                                    options={firmTypeOptions}
                                    placeholder="-- Select Firm Type --"
                                    classNamePrefix="react-select"
                                    className={formSubmitted && !form.firm_type ? 'is-invalid fs-9' : 'fs-9'}
                                />
                                {formSubmitted && !form.firm_type && (
                                    <div className="invalid-feedback d-block">Firm Type is required.</div>
                                )}
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2 fs-9">
                                <Form.Label>GST Registration Type</Form.Label>
                                <Select
                                    name="gst_registration"
                                    value={gstRegistrationOptions.find(opt => opt.value === form.gst_registration)}
                                    onChange={handleSelectChange}
                                    options={gstRegistrationOptions}
                                    placeholder="-- Select GST Type --"
                                />
                            </Form.Group>
                        </Col>

                        {form.gst_registration === 'registered' && (
                            <Col md={6} xl={4}>
                                <Form.Group className="mb-2">
                                    <Form.Label>GSTIN</Form.Label>
                                    <Form.Control
                                        name="gstin"
                                        value={form.gstin}
                                        onChange={handleChange}
                                        isInvalid={form.gstin && !isValidGSTIN(form.gstin)}
                                    />
                                    <Form.Control.Feedback type="invalid">Invalid GSTIN format.</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        )}

                        <hr className="my-3" />

                        {/* Owner & Contact */}
                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Owner Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="owner_name"
                                    value={form.owner_name}
                                    onChange={(e) => handleOwnerChange('owner_name', e.target.value)}
                                    isInvalid={formSubmitted && !form.owner_name}
                                />
                                <Form.Control.Feedback type="invalid">Owner name is required.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Owner Contact Number <span className="text-danger">*</span></Form.Label>
                                <PhoneInput
                                    country="in"
                                    value={form.owner_contact_no}
                                    onChange={(value) => handleOwnerChange('owner_contact_no', `+${value}`)}
                                    inputProps={{ name: 'owner_contact_no' }}
                                    inputClass={
                                        formSubmitted && (!form.owner_contact_no || !isValidPhone(form.owner_contact_no))
                                            ? 'is-invalid' : ''
                                    }
                                />
                                {formSubmitted && !form.owner_contact_no && (
                                    <div className="invalid-feedback d-block">Owner Contact Number is required.</div>
                                )}
                                {form.owner_contact_no && !isValidPhone(form.owner_contact_no) && (
                                    <div className="invalid-feedback d-block">Invalid phone number format.</div>
                                )}
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Business Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="business_email"
                                    value={form.business_email}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <hr className="my-3" />

                        {/* Address */}
                        <Col md={12}>
                            <Form.Group className="mb-2">
                                <Form.Label>Full Address <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="address"
                                    value={form.address}
                                    onChange={handleChange}
                                    isInvalid={formSubmitted && !form.address}
                                />
                                <Form.Control.Feedback type="invalid">Address is required.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Town <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="town"
                                    value={form.town}
                                    onChange={handleChange}
                                    isInvalid={formSubmitted && !form.town}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>City <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="city"
                                    value={form.city}
                                    onChange={handleChange}
                                    isInvalid={formSubmitted && !form.city}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>State <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="state"
                                    value={form.state}
                                    isInvalid={formSubmitted && !form.state}
                                />
                                <Form.Control.Feedback type="invalid">State is required.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Pincode <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="pin_code"
                                    value={form.pin_code}
                                    isInvalid={formSubmitted && (!form.pin_code || !isValidPincode(form.pin_code))}
                                />
                                <Form.Control.Feedback type="invalid">Pincode must be exactly 6 digits.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <hr className="my-3" />

                        {/* Extra Info */}
                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Credit Period Allowed</Form.Label>
                                <Form.Control
                                    name="credit_period_allowed"
                                    value={form.credit_period_allowed}
                                    onChange={handleChange}
                                    placeholder="e.g. 30 days"
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>PAN No.</Form.Label>
                                <Form.Control name="pan_no" value={form.pan_no} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>TAN No.</Form.Label>
                                <Form.Control name="tan_no" value={form.tan_no} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>FSSAI No.</Form.Label>
                                <Form.Control name="fssai_no" value={form.fssai_no} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4} className="d-flex align-items-center">
                            <Form.Group className="mb-2 mt-4">
                                <Form.Check
                                    type="checkbox"
                                    name="isInHouse"
                                    checked={form.isInHouse || false}
                                    onChange={handleChange}
                                    label="Mark as In-House Buyer"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" variant="primary">Update Buyer</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default BuyerEditModal;
